import React, { useEffect } from "react";
import { RouteComponentProps, useLocation, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { RootState } from "store/store";
import qs from "qs";
import { nextEngineAuthorize } from "./ClientLinkActions";
import { Row, Spin } from "antd";
import { CustomError, ErrorWrapper } from "errors/errors";
import ErrorDisplay from "components/ErrorDisplay";
import { Page } from "features/appstate/AppStateSlice";
import { MODE_SURVEY, surveyTypeEc, UI_BASE } from "../../constants";

interface ClientLinkProps {
  clientNextEngineLinkLoading: boolean;
  nextEngineAuthorize: (
    uid: string,
    state: string,
    onSuccess: () => void
  ) => void;
  error?: CustomError;
}

const ClientLink: React.FC<ClientLinkProps & RouteComponentProps> = ({
  clientNextEngineLinkLoading,
  nextEngineAuthorize,
  error,
}) => {
  const history = useHistory();
  const location = useLocation();
  const parsed = qs.parse(location.search, { ignoreQueryPrefix: true });
  const uid = parsed.uid;
  const state = parsed.state;
  // const mode = parsed.mode;
  // const surveyType = parsed.surveyType;

  useEffect(() => {
    // Redirect is for next engine link
    if (uid && state && !clientNextEngineLinkLoading) {
      nextEngineAuthorize(uid as string, state as string, () => {
        window.location = `${UI_BASE}/${Page.ecSettings}?linkFinished=true&mode=${MODE_SURVEY}&surveyType=${surveyTypeEc}` as any;
      });
    }
  }, [uid, state, clientNextEngineLinkLoading, history]);

  if (error) {
    const wrappedError: ErrorWrapper = { error };
    return <ErrorDisplay error={wrappedError} />;
  }

  return (
    <>
      <Row justify="center" align="middle" style={{ minHeight: "100vh" }}>
        <Spin size="large" />
      </Row>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    clientNextEngineLinkLoading: state.clientLink.clientNextEngineLinkLoading,
    error: state.clientLink.error,
  };
};
const mapDispatchToProps = {
  nextEngineAuthorize,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientLink);
